var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFavorite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 97.092 97.092",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M96.994,37.479c-0.236-0.725-0.862-1.253-1.617-1.361l-31.141-4.494L50.34,3.396c-0.336-0.684-1.032-1.117-1.794-1.117 c-0.762,0-1.458,0.433-1.794,1.116L32.855,31.623l-31.14,4.494c-0.754,0.108-1.381,0.637-1.617,1.361 c-0.235,0.725-0.039,1.521,0.508,2.052l22.551,21.939l-5.348,31.004c-0.13,0.75,0.179,1.51,0.795,1.957 c0.618,0.449,1.434,0.508,2.108,0.152l27.834-14.668L76.38,94.582c0.293,0.154,0.612,0.23,0.933,0.23 c0.415,0,0.827-0.129,1.176-0.383c0.616-0.447,0.926-1.207,0.795-1.957l-5.348-31.004l22.551-21.939 C97.031,38.999,97.229,38.203,96.994,37.479z M82.965,43.436L66.763,59.197l3.842,22.273c0.093,0.541-0.129,1.086-0.571,1.408 c-0.25,0.182-0.547,0.273-0.845,0.273c-0.229,0-0.459-0.055-0.67-0.165L48.521,72.449L28.524,82.988 c-0.485,0.256-1.072,0.213-1.515-0.109c-0.442-0.32-0.664-0.867-0.571-1.406l3.842-22.274L14.077,43.436 c-0.392-0.383-0.534-0.953-0.364-1.475c0.169-0.521,0.619-0.9,1.161-0.978l22.373-3.229l9.984-20.28 c0.242-0.491,0.742-0.802,1.29-0.802c0.547,0,1.046,0.311,1.289,0.802l9.985,20.28l22.373,3.229 c0.542,0.077,0.991,0.457,1.161,0.978C83.499,42.482,83.356,43.052,82.965,43.436z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFavorite);
export default __webpack_public_path__ + "static/media/icon-favorite.1acb006120e669c694a3ac4bbd1881d5.svg";
export { ForwardRef as ReactComponent };